'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('./constants');

var constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  data: function data() {
    return {
      $_fullPageMixin_refName: 'fullPage'
    };
  },


  methods: _extends({}, constants.METHODS.reduce(function (methods, method) {
    return _extends({}, methods, _defineProperty({}, method, function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (args[0] instanceof Event) {
        args.shift();
      }

      if (args.length) {
        $.fn.fullpage[method].apply(undefined, args);
      } else {
        $.fn.fullpage[method]();
      }
    }));
  }, {}))
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-fullpage.js/src/fullPageMixin.js
// module id = 307
// module chunks = 0